import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "@mui/material/Select";
import Input from "@mui/material/Input";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import Checkbox from '@mui/material/Checkbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CountrySelect from '../../components/searchBar/CountrySelect';
import DateRangeFilter from '../../components/searchBar/DateRangeFilter';
import {
  DEFAULT_FCS_DEPOSIT_WITHDRAW_STATE,
} from "../../constants/constants";
import * as types from '../../constants/actionTypes';
import AddCircle from '@mui/icons-material/AddCircle';
import PaymentMethod from '../DepositReport/PaymentMethod';
// ⚠️ FCS 报表用专用 FcsPaymentStatus 组件,调 /api/fcs/payment-status
// (FCS 自己的 endpoint,状态机跟 hytech-payment Java 1:1)
import FcsPaymentStatus from '../DepositReport/FcsPaymentStatus';
import PaymentChannel from '../DepositReport/PaymentChannel';
import UserLevelFilter from "../../components/searchBar/UserLevelFilter";
import { makeStyles } from "@mui/styles";
import theme from '../../constants/theme';


const useStyles = makeStyles(() => ({
  formControl: {
    margin: theme.spacing(1),
    display: "flex",
    fontStyle: "italic",
  },
  selectControl: {
    width: 250,
  },
  selectedFilters: {
    display: "flex",
    flexWrap: "wrap",
  },
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const FcsDepositWithdrawFilter = () => {
  const classes = useStyles();
  const { filters, levelId, showAll, userAndLevelName, countryList, selectedCountries, fcsDepositWithdrawState } = useSelector((state) => state.report);
  const dispatch = useDispatch();
  const setFilters = (filters) => dispatch({ type: types.SET_FILTERS, filters });
  const selectCountries = (val) => dispatch({ type: types.SET_SELECTED_COUNTRIES, value: val });
  const setFcsDepositWithdrawState = (val) => dispatch({ type: types.SET_FCS_DEPOSIT_WITHDRAW_STATE, value: val });
  const setSelectedContinents = (val) => dispatch({ type: types.SET_CONTINENTS_LIST, value: val });
  const setUserAndLevelName = (val) => dispatch({ type: types.SET_USER_AND_LEVEL_NAME, value: val });
  const setLevelId = (val) => dispatch({ type: types.SET_LEVEL_ID, value: val });
  const setShowAll = (val) => dispatch({ type: types.SET_SHOW_ALL, value: val });

  const filterList = [
    {
      label: "Date Range",
      value: "dateRange",
      keys: ["fromDate", "toDate"],
      required: true,
    },
    {
      label: "User & Level",
      value: "userAndLeve",
      keys: ["userAndLeve"],
      required: true,
    },
    {
      label: "Country",
      value: "country",
      keys: ["countryCodes"],
      show: true,
    },
    {
      label: "Payment Status",
      value: "paymentStatus",
      keys: ["paymentStatus"],
      show: true,
    },
    {
      label: "Payment Method",
      value: "paymentMethod",
      keys: ["paymentMethod"],
      show: true,
    },
    {
      label: "Payment Channel",
      value: "paymentChannel",
      keys: ["paymentChannel"],
      show: true,
    },
  ];

  const [selectedFilters, setSelectedFilters] = useState(
    filterList.filter((r) => r.required || r.show).map((r) => r.value)
  );

  const toggleFilter = (val) => {
    setSelectedFilters(val);
    const filterKeys = filterList
      .filter((r) => val.includes(r.value))
      .flatMap((r) => r.keys);
    const newFilters = { ...fcsDepositWithdrawState};
    Object.keys(fcsDepositWithdrawState).forEach((r) => {
      if (!(filterKeys.includes(r) || ['withdraw','deposit'].includes(r))) {
        newFilters[r] = DEFAULT_FCS_DEPOSIT_WITHDRAW_STATE[r];
      }
    });
    setFcsDepositWithdrawState(newFilters)
    if (!filterKeys.includes('countryCodes')) {
      selectCountries([]);
      setSelectedContinents([]);
    }
  };

  const isVisible = (id) => {
    return selectedFilters.includes(id);
  };

  const selectedFilterCount = selectedFilters.length;

  const onClickWithdraw = e => {
    setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, 'withdraw': !fcsDepositWithdrawState['withdraw']});
  };
  const onClickDeposit = e => {
    setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, 'deposit': !fcsDepositWithdrawState['deposit']});
  };

  useEffect(() => {
    const {
      fromDate,
      toDate,
      deposit,
      withdraw,
      depositDataType,
      depositPaymentStatus,
      depositPaymentMethod,
      depositPaymentChannel,
      withdrawDataType,
      withdrawPaymentStatus,
      withdrawPaymentMethod,
      withdrawPaymentChannel,
    } = fcsDepositWithdrawState;

    const codes = selectedCountries.map(r => r.value).join(',');
    setFilters({
      fromDate,
      toDate,
      deposit,
      withdraw,
      depositDataType,
      depositPaymentStatus,
      depositPaymentMethod,
      depositPaymentChannel,
      withdrawDataType,
      withdrawPaymentStatus,
      withdrawPaymentMethod,
      withdrawPaymentChannel,
      countryCodes: codes || undefined,
      levelId,
      showAll
    });
  }, [fcsDepositWithdrawState, selectedCountries, levelId, showAll]);

  return (
    <>
      <div className={classes.formControl}>
        <InputLabel id="filter-mutiple-checkbox-label">
          <AddCircle color="primary" />
        </InputLabel>
        <Select
          className={classes.selectControl}
          labelId="filter-mutiple-checkbox-label"
          id="filter-mutiple-checkbox"
          multiple
          value={selectedFilters}
          onChange={(e) => toggleFilter(e.target.value)}
          input={<Input />}
          renderValue={(selected) => `${selectedFilterCount} filters selected`}
        >
          {filterList.map((option) => (
            <MenuItem
              key={option.value}
              disabled={option.required}
              value={option.value}
            >
              <Checkbox
                color="primary"
                checked={selectedFilters.includes(option.value)}
              />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </div>
      <DateRangeFilter
        selectedFromDate={fcsDepositWithdrawState.fromDate}
        setSelectedFromDate={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, fromDate: val })}
        selectedToDate={fcsDepositWithdrawState.toDate}
        setSelectedToDate={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, toDate: val })}
      />

      {isVisible("userAndLeve") && (
          <UserLevelFilter
            levelId={levelId}
            setLevelId={setLevelId}
            showAll={showAll}
            setShowAll={setShowAll}
            userAndLevelName={userAndLevelName}
            setUserAndLevelName={setUserAndLevelName}
          />
        )}

      {isVisible("country") && (
        <CountrySelect
           data={countryList}
           onChange={(val) => selectCountries(val)}
           value={selectedCountries}
         />
      )}

    <List component="nav" aria-labelledby="nested-list-subheader" className={classes.root}>
      <ListItem button onClick={onClickDeposit}>
        <ListItemIcon>
          <Checkbox className={classes.checkbox} checked={fcsDepositWithdrawState.deposit} color="primary"/>
        </ListItemIcon>
        <ListItemText primary="Deposit" />
        {fcsDepositWithdrawState.deposit ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={fcsDepositWithdrawState.deposit} timeout="auto" unmountOnExit>
      {isVisible('paymentStatus') && (<FcsPaymentStatus
        id="multiple-deposit-status-select"
        value={fcsDepositWithdrawState.depositPaymentStatus}
        dataType={fcsDepositWithdrawState.depositDataType}
        onChange={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, depositPaymentStatus: val})}
      />)}
      {isVisible('paymentMethod') && (<PaymentMethod
          value={fcsDepositWithdrawState.depositPaymentMethod}
          dataType={fcsDepositWithdrawState.depositDataType}
          onChange={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, depositPaymentMethod: val, depositPaymentChannel: ''})}
      />)}
      {isVisible('paymentChannel') && (<PaymentChannel
          value={fcsDepositWithdrawState.depositPaymentChannel}
          dataType={fcsDepositWithdrawState.depositDataType}
          paymentMethod={fcsDepositWithdrawState.depositPaymentMethod}
          onChange={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, depositPaymentChannel: val})}
      />)}
      </Collapse>
      <ListItem button onClick={onClickWithdraw}>
        <ListItemIcon>
          <Checkbox className={classes.checkbox} checked={fcsDepositWithdrawState.withdraw} color="primary"/>
        </ListItemIcon>
        <ListItemText primary="Withdraw" />
        {fcsDepositWithdrawState.withdraw ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={fcsDepositWithdrawState.withdraw} timeout="auto" unmountOnExit>
        {isVisible('paymentStatus') && (<FcsPaymentStatus
            id="multiple-withdraw-status-select"
            value={fcsDepositWithdrawState.withdrawPaymentStatus}
            dataType={fcsDepositWithdrawState.withdrawDataType}
            onChange={(val) => {
              setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, withdrawPaymentStatus: val});
            }}
        />)}
        {isVisible('paymentMethod') && (<PaymentMethod
            value={fcsDepositWithdrawState.withdrawPaymentMethod}
            dataType={fcsDepositWithdrawState.withdrawDataType}
            onChange={(val) => setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, withdrawPaymentMethod: val, withdrawPaymentChannel: ''})}
        />)}
        {isVisible('paymentChannel') && (<PaymentChannel
            value={fcsDepositWithdrawState.withdrawPaymentChannel}
            dataType={fcsDepositWithdrawState.withdrawPaymentMethod === 1
              ? fcsDepositWithdrawState.depositDataType
              : fcsDepositWithdrawState.withdrawDataType}
            paymentMethod={fcsDepositWithdrawState.withdrawPaymentMethod}
            onChange={(val) => {
              setFcsDepositWithdrawState({ ...fcsDepositWithdrawState, withdrawPaymentChannel: val})
            }}
        />)}
      </Collapse>
    </List>
    </>
  );
};

export default FcsDepositWithdrawFilter;
